//
// AGNES - Technical Support Web
//
// Application.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

"use strict";
global.jQuery = require("jquery");

const angular = require("angular");
require("bootstrap");
require("angular-translate");
require("angular-ui-router");
require("ngstorage");
require("@tce/kobe-oidc");
require("angular-ui-bootstrap");
require("ui-select");
require("ui-select");
require("angular-ui-switch");
require("angular-ui-mask");
require("ng-file-upload");
require("angular-translate-loader-static-files");
require("angular-cookies");
require("angular-file-saver");
require("moment");
require("angular-moment");

angular.isUndefinedNullOrEmpty = function (val) {
    return angular.isUndefined(val) || val === null || val.length === 0;
};

angular
    .module(
        "Agnes",
        [
            "pascalprecht.translate",
            "ui.router",
            "ui.bootstrap",
            "ui.select",
            "uiSwitch",
            "ui.mask",
            "ngStorage",
            "kobeOIDC",
            "ngFileUpload",
            "ngCookies",
            "ngFileSaver",
            "angularMoment"
        ]
    );

require("./Routing");
require("./Config");
require("./Auth");
require("./UserService");
require("./ActivityService");
require("./NotificationService");
require("./MessageBoxService");
require("./AddressLookupService");

require("./HomeController");
require("./MainController");
require("./MenuPricingCatalogController");
require("./MenuPricingMenuController");
require("./MenuPricingGenerateReportController");
require("./MessageBoxController");
require("./RepairerProfileController");
require("./TechnicalSupportApprovedController");
require("./TechnicalSupportBrowseController");
require("./TechnicalSupportBrowseEvaluationController");
require("./TechnicalSupportBrowseTechReportController");
require("./TechnicalSupportDetailController");
require("./TechnicalSupportFormUploadController");
require("./TechnicalSupportPendingController");
require("./WarrantyContractBrowseController");
require("./WarrantyContractCreateController");
require("./WarrantyContractDetailController");
require("./CarInfoController");
require("./ReportsController");
require("../Styles/Agnes.less");